interface ProductCustomAttributes {
    [key: string]: string
}

export const productCustomAttributes: ProductCustomAttributes = {
    advertencias: 'Advertencias',
    antideslizante: 'Antideslizante',
    apertura_paraguas: 'Apertura paraguas',
    aroma: 'Aroma',
    blackout: 'Blackout',
    cantidad_de_hilos: 'Cantidad de hilos',
    cantidad_de_hojas: 'Cantidades de hojas',
    cantidad_de_luces: 'Cantidad de luces',
    cantidad_de_piezas: 'Cantidad de piezas',
    cantidad_de_pilas: 'Cantidad de pilas',
    capacidad: 'Capacidad',
    capacidad_en_litros: 'Capacidad en litros',
    capacidad_en_ml: 'Capacidad en ml',
    card_price: 'card_price',
    composicion: 'Composición',
    cuidados: 'Cuidados',
    diseno_pais_origen: 'Diseño y país de origen',
    edad_recomendada_texto: 'Edad recomendada',
    fijacion: 'Fijación',
    formato_de_fotos: 'Formato de foto',
    formato_libros: 'Formato libros',
    frecuencia: 'Frecuencia',
    fuente_de_poder: 'Fuente de poder',
    gramaje_del_papel: 'Gramaje del papel',
    gramos_por_pieza: 'Gramos por pieza',
    gsm: 'Gsm',
    g_talla: 'Talla',
    hecho_a_mano: 'Hecho a mano',
    incluye_bombilla_ampolleta: 'Incluye bombilla (ampolleta)',
    instrucciones: 'Instrucciones de armado o recomendaciones de uso',
    largo_del_cable: 'Largo del cable',
    medidas_de_embalaje_y_peso: 'Medidas de embalaje y peso',
    medidas_y_materialidad: 'Medidas y materialidad',
    peso_maximo: 'Peso máximo',
    pintado_a_mano: 'Pintado a mano',
    rese_a: 'Reseña',
    tamano_fotos: 'Tamaño fotos',
    tiempo_de_quemado: 'Tiempo de quemado',
    tiempo_que_dura_el_agua_calien: 'tiempo que dura el agua caliente',
    tipo_de_ampolleta: 'Tipo de ampolleta',
    tipo_de_conexion: 'Tipo de conexión',
    tipo_de_encuadernacion: 'Tipo de encuadernación',
    tipo_de_fijacion: 'Tipo de fijación',
    tipo_de_hojas: 'Tipos de hojas',
    tipo_de_luz: 'Tipo de luz',
    tipo_de_mina: 'Tipo de mina',
    tipo_de_pilas: 'Tipos de pilas',
    tipo_de_punta: 'Tipo de punta',
    tipo_de_semilla: 'Tipo de semilla',
    tipo_de_sustrato: 'Tipo de sustrato',
    tipo_de_tinta: 'Tipo de tinta',
    velas_led_tipo_de_luz: 'Velas led (tipo de luz)',
    voltaje: 'Voltaje',
    watts: 'Watts'
}
